var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhDistNotigication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_456_2896",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_456_2896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4217 3.80517C9.92516 2.79878 10.0275 1.98575 10.6947 1.4148C10.9883 1.1617 11.3576 1.01602 11.743 1.00125C12.1284 0.986469 12.5075 1.10345 12.8192 1.33334C13.5601 1.89744 13.6865 2.68459 13.2171 3.76939C13.7271 4.0031 14.2613 4.19646 14.7442 4.47889C16.8303 5.69691 17.9113 7.55744 18.0279 9.98131C18.0783 11.0471 18.1031 12.1128 18.073 13.1786C18.049 14.0761 18.3258 14.8443 18.8253 15.556C19.2097 16.1042 19.6069 16.6439 19.9688 17.2057C20.3509 17.7987 20.5931 18.4488 20.5999 19.1698C20.6052 19.8184 20.3697 20.1076 19.7416 20.1952C19.456 20.2325 19.1682 20.25 18.8802 20.2477C14.1424 20.2508 9.40484 20.2508 4.66752 20.2477C4.40445 20.249 4.14158 20.2328 3.88063 20.199C3.23518 20.1137 2.96964 19.7696 3.00274 19.1081C3.04562 18.2517 3.40596 17.5224 3.87613 16.835C4.27483 16.2518 4.69084 15.6794 5.07074 15.0841C5.41152 14.5512 5.53339 13.9505 5.54166 13.3103C5.55821 11.9545 5.49427 10.5835 5.67105 9.24669C6.0171 6.62489 7.53669 4.88921 9.97631 3.96808C10.1155 3.91555 10.2562 3.86531 10.4217 3.80517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 20.8C13.9866 21.9019 12.9745 22.9495 11.8916 22.9981C10.7573 23.0506 9.69462 22.0428 9.6001 20.8H14.0001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhDistNotigication);
export default __webpack_public_path__ + "static/media/wh_dist_notigication.7d59d6e0cb20dc97764826ffb6d78fc5.svg";
export { ForwardRef as ReactComponent };